/**
 * Shows a banner when the session is close to timing out from inactivity (the
 * 130-minute idle window). Any interaction slides the expiry forward via
 * keepalive, so this only appears once the learner has actually gone idle —
 * a nudge to interact or wrap up before they're signed out.
 */
import { useEffect, useState } from "react";
import { useAuth } from "../auth/AuthContext";

const WARN_AT_MIN = 10; // start warning when this many minutes remain

export function SessionExpiryWarning() {
  const { user } = useAuth();
  const [now, setNow] = useState(Date.now());
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const expiresAt = user?.session_expires_at ? new Date(user.session_expires_at).getTime() : null;
  if (!expiresAt) return null;

  const msLeft = expiresAt - now;
  const minLeft = msLeft / 60000;
  if (minLeft > WARN_AT_MIN || msLeft <= 0 || dismissed) return null;

  const m = Math.floor(msLeft / 60000);
  const s = Math.floor((msLeft % 60000) / 1000);

  return (
    <div className="session-warning" role="alert">
      <span>
        ⏳ You've been idle — your session ends in{" "}
        <strong>{m}:{String(s).padStart(2, "0")}</strong>. Move or click to stay signed in.
      </span>
      <button className="session-warning-dismiss" onClick={() => setDismissed(true)} aria-label="Dismiss">
        ✕
      </button>
    </div>
  );
}
